import { createStructuredSelector } from 'reselect';

import { fetchGAWState } from './LoadingPageSelectors';

export const selectAmount = (state) => {
  const { grantAllocation } = fetchGAWState(state);
  if (
    grantAllocation &&
    grantAllocation.amountAllocation &&
    grantAllocation.amountAllocation.amount
  ) {
    return grantAllocation.amountAllocation.amount;
  }
  return '';
};

export const selectFundPool = (state) => {
  const { fundPool } = fetchGAWState(state);
  return fundPool;
};

export const selectAccountsData = (state) => {
  const { accountData } = fetchGAWState(state);
  return accountData.data;
};

export const selectAllocationPayment = (state) => {
  const { grantAllocation } = fetchGAWState(state);
  if (
    grantAllocation &&
    grantAllocation.paymentComponent &&
    grantAllocation.paymentComponent.payment
  ) {
    return grantAllocation.paymentComponent.payment;
  }
  return [];
};

export const selectPurposeDescriptions = (state) => {
  const { purpose } = fetchGAWState(state);
  return purpose.description;
};

export const selectEditMode = (state) => {
  const { edit } = fetchGAWState(state);
  return edit;
};

export const selectGrantAllocationSelect = (state) => {
  const { grantAllocationSelect } = fetchGAWState(state);
  return grantAllocationSelect;
};

export const selectPoolsAllocation = (state) => {
  const { poolsAllocation } = fetchGAWState(state);
  return poolsAllocation;
};

export const selectPoolsAllocationLoading = (state) => {
  const { poolsAllocationLoading } = fetchGAWState(state);
  return poolsAllocationLoading;
};

export const allocationScheduleDerivedStates = createStructuredSelector({
  amount: selectAmount,
  fundPool: selectFundPool,
  accountData: selectAccountsData,
  payment: selectAllocationPayment,
  purposeDescription: selectPurposeDescriptions,
  editMode: selectEditMode,
  grantAllocationDropDown: selectGrantAllocationSelect,
  poolsAllocation: selectPoolsAllocation,
  allocationLoading: selectPoolsAllocationLoading,
});
